// extracted by mini-css-extract-plugin
export default {"homepage":"HomepageTemplate_homepage__tSqgZ"};